import { useTranslator } from '@Localization';
import { Button } from '@mui/joy';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { useHistory } from 'react-router';
import { Loader } from '../../../../__legacy__/components/Loader';
import { toLocaleDateString } from '../../../../__legacy__/helpers/date.helpers';
import { Home } from '../../../../__legacy__/routes/config/Home';
import { S_Card } from '../../../../design/card/card/S_Cards';

interface IClarificationsOverviewProps {
  isLoading: boolean;
  toClarify: number;
  oldestWaitingSince?: string;
  unclearImageId?: string;
  unclearImagesFilterId?: string;
  projectId: string;
  workspaceId: string;
}

export const ClarificationsOverview = observer((props: IClarificationsOverviewProps): ReactElement => {
  const { t } = useTranslator();
  const history = useHistory();

  const { toClarify, workspaceId, projectId, unclearImageId, unclearImagesFilterId, oldestWaitingSince } = props;

  return (
    <S_Card className='overview-card card-with-list'>
      <Loader isLoading={props.isLoading}>
        <div className='info'>
          <h5>{t('stopped_annotations')}</h5>
          <div className='list-row'>
            <div className='left'>{t('waiting_for_clarification')}</div>
            <div className='right'>{toClarify}</div>
          </div>
          {oldestWaitingSince && (
            <div className='list-row'>
              <div className='left'>{t('oldest_waiting_since')}</div>
              <div className='right'>{toLocaleDateString(oldestWaitingSince)}</div>
            </div>
          )}
        </div>
        <div className='bottom'>
          {unclearImageId && unclearImagesFilterId && (
            <Button
              onClick={() => {
                history.push(Home.FreeAccess.View.withParams({ projectId, workspaceId, imageId: unclearImageId, filterId: unclearImagesFilterId }));
              }}
            >
              {t('clarifications.answer_clarification_button')}
            </Button>
          )}
        </div>
      </Loader>
    </S_Card>
  );
});
